import { AxiosInstance } from 'axios'

import { BaseAPI } from '../../classes/BaseAPI'

export class ConsultationAPI extends BaseAPI {
  constructor(axios: AxiosInstance) {
    super(axios)
  }
}
